import React, { useRef, useState } from "react";
import Divider from '@mui/material/Divider';
import Box from "@mui/material/Box";
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material";

interface IEditMessageProps {
  editMessage: any;
  setEditMessage: (x: any) => void;
}


export const EditMessage = (props: IEditMessageProps) => {
  //props
  const { editMessage, setEditMessage } = props
  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEditMessage({ ...editMessage, [name]: value })
  }

  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <FormControl>
            <FormLabel>Cible</FormLabel>
            <RadioGroup
              row
              name="targetAppId"
              value={editMessage.targetAppId}
              onChange={handleInputChange}
            >
              <FormControlLabel value={"FOCUS"} control={<Radio />} label="Focus-Ecole" />
              <FormControlLabel value={"PXP2021"} control={<Radio />} label="Prof-Expert" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item md={12} xs={12} sm={12}><Divider /></Grid>
        <Grid item md={12} xs={12} sm={12}>
          <FormControl>
            <FormLabel>Niveau d'alerte</FormLabel>
            <RadioGroup
              row
              name="alertLevel"
              value={editMessage.alertLevel}
              onChange={handleInputChange}
            >
              <FormControlLabel value={"Info"} control={<Radio size="small" color="info" />} label="Information" />
              <FormControlLabel value={"Success"} control={<Radio size="small" color="success" />} label="Succès" />
              <FormControlLabel value={"Warning"} control={<Radio size="small" color="warning" />} label="Avertissement" />
              <FormControlLabel value={"Danger"} control={<Radio size="small" color="error" />} label="Danger" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={6} xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                name="messageTitle"
                label="Titre"
                value={editMessage.messageTitle}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                multiline
                minRows={6}
                name="messageContent"
                label="Saisir le message"
                value={editMessage.messageContent}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};





